/**
 * Vocabularies stored as lookup tables, keyed by table name. Values are rows, not
 * Postgres enums, so adding a value is an insert.
 */
export enum Vocabulary {
  DependencyTypes = 'dependencyTypes',
  DirectiveVerbs = 'directiveVerbs',
  DocumentKinds = 'documentKinds',
  FileKinds = 'fileKinds',
  InstitutionKinds = 'institutionKinds',
  MarkingMethods = 'markingMethods',
  OutcomeAssociationTypes = 'outcomeAssociationTypes',
  QuestionRelationshipTypes = 'questionRelationshipTypes',
  QuestionTypes = 'questionTypes',
  RequirementRelations = 'requirementRelations',
  ResponseTypes = 'responseTypes',
  Scales = 'scales',
  SetTypeTags = 'setTypeTags',
  SolutionProvenance = 'solutionProvenance',
  SourceTypes = 'sourceTypes',
  Subjects = 'subjects',
  TopicGroupNodeTypes = 'topicGroupNodeTypes',
  TopicKinds = 'topicKinds',
  TopicMappingScopes = 'topicMappingScopes',
  TopicMigrationKinds = 'topicMigrationKinds',
}

/** How a scale is scored. Ordinal and count scales take whole numbers only. */
export enum ScaleKind {
  Ordinal = 'ordinal',
  Continuous = 'continuous',
  Count = 'count',
}

/** `document_kinds.code` values from the reference data. */
export enum DocumentKind {
  Questions = 'questions',
  Solutions = 'solutions',
  Combined = 'combined',
  Unknown = 'unknown',
}

/** `source_types.code` values from the reference data. */
export enum SourceType {
  HscExam = 'hsc_exam',
  TrialExam = 'trial_exam',
  SchoolAssessment = 'school_assessment',
  Textbook = 'textbook',
  Workbook = 'workbook',
  QuestionBank = 'question_bank',
  InternallyAuthored = 'internally_authored',
  Other = 'other',
  Unknown = 'unknown',
}

/** `solution_provenance.code` values from the reference data. */
export enum SolutionProvenance {
  ReadFromSource = 'read_from_source',
  HumanAuthored = 'human_authored',
  Generated = 'generated',
}

/** `dependency_types.code` values from the reference data. */
export enum DependencyType {
  Requires = 'requires',
  ReferencesAnswer = 'references_answer',
}
